// @vendors
import React, { useMemo } from 'react'
import { Grid, Menu, MenuItem } from '@mui/material'
import { useSelector } from 'react-redux';

// @context
import { useUI } from '../../../app/context/ui';

// @helpers
import AppHelper from '../../../helpers/AppHelper';
import { downloadTemplate } from '../../../helpers/FunctionsUtils';
import { LISTROLES } from '../../../helpers/ListRoles';

// @services
import CompanyServiceNewApi from '../../../services/newApi/CompanyServiceNewApi';
import EmployeeCompanyServiceNewApi from '../../../services/newApi/EmployeeCompanyServiceNewApi';
import PayrollService from '../../../services/newApi/PayrollService';
import { theme } from '../../../assets/theme';

const MenuDownloadFile = ({anchorElMenu, openMenu, handleCloseMenu}) => {
    const globalState = useSelector((state) => state);
    const user = globalState.user;
    const { blockUI, snackbarUI } = useUI();
    const companyServiceNewApi = useMemo(() => new CompanyServiceNewApi(), []);
    const employeeServiceNewApi = useMemo(() => new EmployeeCompanyServiceNewApi(), []);
    const payrollService = useMemo(() => new PayrollService(), []);

    const fetchTemplate = async (file) => {
        //if(file.id === 9)return fetchTemplateArizona(file);
        try {
          blockUI.current.open(true);
          const response = await file.serviceCall();
          blockUI.current.open(false);
          handleCloseMenu();
          return downloadTemplate(response?.data, file.fileName);
        } catch (error) {
          throwError(error);
        }
    };

    const throwError = (error) => {
        blockUI.current.open(false);
        if(typeof error?.response?.data === 'string' && error?.response?.data?.includes('Error processing the CSV file') )return errorInvalidFile();
        if(error?.response?.data?.errors && error?.response?.data?.errors[0]?.includes('Error processing the CSV file') )return errorInvalidFile();
        AppHelper.checkError(error, snackbarUI);
    }

    const errorInvalidFile = () => {
        snackbarUI.current.open('Error processing the CSV file, verify that the structure is correct.');
    }

    const menuList = [
        {
            id: 1,
            label: 'Add employer',
            serviceCall: () => companyServiceNewApi.getTempleteForAddEmployers(),
            fileName: 'template_add_employer.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 2,
            label: 'Update employer',
            serviceCall: () => companyServiceNewApi.getTempleteForUpdateEmployers(),
            fileName: 'template_update_employer.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 3,
            label: 'Add employees',
            serviceCall: () => employeeServiceNewApi.donwloadTemplete(),
            fileName: 'add_employees_template.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
        {
            id: 4,
            label: 'Update employees',
            serviceCall: () => employeeServiceNewApi.downloadTemplateForUpdateEmployees(),
            fileName: 'update_employees_template.csv',
            roles: [LISTROLES.superAdmin]
        },
        {
            id: 5,
            label: 'Update state certification',
            serviceCall: () => employeeServiceNewApi.getTemplateNsi(true),
            fileName: 'template_state_certification_updates.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 6,
            label: 'NSI',
            serviceCall: () => employeeServiceNewApi.donwloadTempleteNsi(),
            fileName: 'employees_nsi_template.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
        {
            id: 7,
            label: 'Update NSI',
            serviceCall: () => employeeServiceNewApi.getTemplateNsi(false),
            fileName: 'nsi_updates_template.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter]
        },
        {
            id: 8,
            label: 'Payroll',
            serviceCall: () => payrollService.downloadTemplete(),
            fileName: 'add_payroll_file_template.csv',
            roles: [LISTROLES.superAdmin, LISTROLES.orgManager, LISTROLES.orgProcessor, LISTROLES.orgReporter, LISTROLES.employerManager, LISTROLES.employerReporter]
        },
    ];

    const filteredMenu = menuList.filter(item => item.roles.includes(user.role));

  return (
    <Menu
      id="basic-menu"
      anchorEl={anchorElMenu}
      open={openMenu}
      onClose={handleCloseMenu}
      MenuListProps={{ 'aria-labelledby': 'basic-button' }}
    >
        <Grid>
            {filteredMenu.map((item) => (
               
                <MenuItem 
                    key={item.id}
                    onClick={() => fetchTemplate(item)}
                    sx={{
                        color: theme.palette.primary.black
                    }}
                >
                    {item.label}
                </MenuItem>
            ))}
        </Grid>
        
    </Menu>
  )
}

export default MenuDownloadFile